<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
        v-for="breadcrumb in breadcrumbs"
        :key="breadcrumb.name"
        :disabled="typeof breadcrumb.link === 'undefined'"
        :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <h1 class="text-xs-left my-3 ml-3">Активность водителей</h1>
    <v-layout row class="ml-3">
      <v-flex xs12 v-if="$store.getters.user !== null">
        <v-layout row>
          <v-flex xs4 lg4 md4>
            <v-menu
              ref="menu"
              :close-on-content-click="false"
              v-model="menu"
              :nudge-right="40"
              :return-value.sync="date"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              class="mr-3"
              style="z-index: 1001;"
            >
              <v-text-field
                slot="activator"
                v-model="dateFormatted"
                label="Дата"
                readonly
                outline
              ></v-text-field>
              <v-date-picker
                v-model="date"
                @input="inputDate"
                locale="ru"
                :first-day-of-week="1"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs4 lg4 md4 v-if="$store.getters.user.branch === null">
            <v-select
              :items="branchTitleList"
              label="Филиал"
              v-model="branch"
              class="mr-3"
              @input="onBranchSelect()"
              outline
              no-data-text="Нет данных"
              style="z-index: 1001"
            ></v-select>
          </v-flex>

          <v-flex xs4 lg4 md4 v-if="branch !== 'Все филиалы' && branch !== null">
            <v-select
              :items="filialTitleList"
              label="Направление"
              v-model="filial"
              class="mr-3"
              @input="onFilialSelect()"
              outline
              no-data-text="Нет данных"
              style="z-index: 1001"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row class="ml-3">
      <v-flex xs12>
        <div id="leaflet-map" style="width: 100%; height: 700px;"></div>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
  import L from 'leaflet'
  import 'leaflet/dist/leaflet.css'

  export default {
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Активность водителей'}
        ],
        pageDataReady: {
          isReady: false,
          branchList: false
        },
        date: null,
        dateFormatted: null,
        menu: false,
        branch: null,
        branchId: null,
        filial: null,
        filialId: null,
        drivers: [],
        map: null,
        layers: []
      }
    },
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.branchList) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      onBranchSelect () {
        if (this.branch !== null && this.branch !== 'Все филиалы') {
          for (let i = 0; i < this.branchList.length; i++) {
            if (this.branchList[i].title === this.branch) {
              this.branchId = this.branchList[i].id
              break
            }
          }
          this.$store.dispatch('getFilialList', {branchId: this.branchId})
        } else {
          this.branchId = null
        }
        this.updateUrl()
      },
      onFilialSelect () {
        if (this.filial !== null && this.filial !== 'Все направления') {
          for (let i = 0; i < this.filialList.length; i++) {
            if (this.filialList[i].title === this.filial) {
              this.filialId = this.filialList[i].id
              break
            }
          }
        } else {
          this.filialId = null
        }
        this.updateUrl()
      },
      inputDate () {
        this.$refs.menu.save(this.date)
        this.updateUrl()
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}.${month}.${year}`
      },
      getDriverList () {
        if (this.date !== null) {
          let data = {
            date: this.date + ' 00:00:00',
            branchId: this.branchId,
            limit: 1000,
            filialId: this.filialId
          }

          this.$store.dispatch('getDriverList', data)
        } else {
          return false
        }
      },
      initLeaflet () {
        if (this.map === null) {
          // Create Leaflet map on map element.
          this.map = L.map(document.getElementById('leaflet-map'), {
            preferCanvas: true,
            center: L.latLng(51.533103, 46.034158),
            zoom: 12
          })

          // Add OSM tile layer to the Leaflet map.
          L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          }).addTo(this.map)
        } else {
          for (let i in this.layers) {
            this.map.removeLayer(this.layers[i])
          }
          this.layers = []
        }

        for (let d in this.DriverList) {
          let driver = this.DriverList[d]

          if (driver.coordinate === null) {
            continue
          }

          let latLng = L.latLng(driver.coordinate.lat, driver.coordinate.lng)
          let marker = L.marker(latLng, {
            icon: new L.Icon({
              iconUrl: '/static/img/maps-and-flags.svg',
              iconRetinaUrl: '/static/img/maps-and-flags.svg',
              shadowUrl: null,
              iconSize: [36, 36]
            })
          }).bindPopup(`<b><a href="/drivers/single/${this.date}/${driver.user.id}">` + driver.user.first_name + ` ` + driver.user.surname + `</a></b>`).addTo(this.map)

          this.layers.push(marker)
        }

        if (this.layers.length > 0) {
          this.map.fitBounds((new L.FeatureGroup(this.layers)).getBounds())
        }
      },
      updateUrl () {
        let filter = ''
        if (this.date !== null) {
          filter += '?date=' + this.date
        }

        if (this.branchId !== null) {
          if (filter === '') {
            filter += '?branch_id=' + this.branchId
          } else {
            filter += '&branch_id=' + this.branchId
          }
        }

        if (this.filialId !== null) {
          if (filter === '') {
            filter += '?filial_id=' + this.filialId
          } else {
            filter += '&filial_id=' + this.filialId
          }
        }

        this.$router.push('/drivers/activity' + filter)
      }
    },
    computed: {
      DriverList () {
        return this.$store.getters.DriverList
      },
      branchTitleList () {
        return this.$store.getters.branchTitleList
      },
      filialTitleList () {
        return this.$store.getters.filialTitleList
      },
      branchList () {
        return this.$store.getters.branchList
      },
      filialList () {
        return this.$store.getters.filialList
      },
      loading () {
        return this.$store.getters.loading
      },
      totalCount () {
        return this.$store.getters.driverTotalCount
      }
    },
    created () {
      this.$store.commit('setPageLoading', true)
      this.$store.commit('setPageTitle', 'Активность водителей')
      this.$store.dispatch('getBranchList')
        .then(() => {
          this.pageDataReady.branchList = true
          this.pageDataStatus()
        })

      if (typeof this.$router.currentRoute.query.date !== 'undefined') {
        this.date = this.$router.currentRoute.query.date
      } else {
        this.date = this.$moment().format('YYYY-MM-DD')
      }
      if (typeof this.$router.currentRoute.query.branch_id !== 'undefined') {
        this.branchId = this.$router.currentRoute.query.branch_id
      }

      if (typeof this.$router.currentRoute.query.filial_id !== 'undefined') {
        this.filial_id = this.$router.currentRoute.query.filial_id
      }
    },
    watch: {
      DriverList (val) {
        this.drivers = this.DriverList
        this.initLeaflet()
      },
      date (val) {
        this.dateFormatted = this.formatDate(this.date.replace(/\s/, 'T'))
        this.getDriverList()
      },
      branchId (val) {
        this.getDriverList()
      },
      filialId (val) {
        this.getDriverList()
      },
      branchList (val) {
        if (this.$store.getters.user.branch !== null && this.branchId === null) {
          const currentBranch = this.branchList.find(item => item.id === parseInt(this.$store.getters.user.branch.id))

          if (currentBranch) {
            this.branch = currentBranch.title
            this.branchId = currentBranch.id
            this.$store.dispatch('getFilialList', {branchId: this.branchId})
          }
        }

        if (typeof this.$router.currentRoute.query.branch_id !== 'undefined') {
          const currentBranch = this.branchList.find(item => item.id === parseInt(this.$router.currentRoute.query.branch_id))
          this.branch = currentBranch.title
          this.branchId = currentBranch.id
          this.$store.dispatch('getFilialList', {branchId: this.branchId})
        }
      },
      filialList () {
        if (this.$store.getters.user.filial_id !== null && this.filialId === null) {
          const currentFilial = this.filialList.find(item => item.id === parseInt(this.$store.getters.user.filial_id))

          if (currentFilial) {
            this.filial = currentFilial.title
            this.filialId = currentFilial.id
          }
        }

        if (typeof this.$router.currentRoute.query.filial_id !== 'undefined') {
          const currentFilial = this.filialList.find(item => item.id === parseInt(this.$router.currentRoute.query.filial_id))

          if (currentFilial) {
            this.filial = currentFilial.title
            this.filialId = currentFilial.id
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Drivers/DriverActivity.vue